import { ArrowLeftTopBoldIcon } from './ArrowLeftTopBoldIcon';

/**
 * author: Colton Wiscombe
 * id 1239A338-77EE-47E5-A50B-2BC667AD7BB1
 * name arrow-left-top-bold
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-left-top-bold.svg
 * tags
 */
export const TurnLeftBoldIcon = ArrowLeftTopBoldIcon;
export default TurnLeftBoldIcon